import { render, staticRenderFns } from "./InspirationPreview.vue?vue&type=template&id=810e34be"
import script from "./InspirationPreview.vue?vue&type=script&lang=ts"
export * from "./InspirationPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports